import { render } from "./MainCarousel.vue?vue&type=template&id=07709ec0"
import script from "./MainCarousel.vue?vue&type=script&lang=js"
export * from "./MainCarousel.vue?vue&type=script&lang=js"

import "./MainCarousel.vue?vue&type=style&index=0&id=07709ec0&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__